import { useMemo } from 'react'
import { useUserStore } from '../store/userStore'

/**
 * Returns whether AdSense surfaces should be shown for the current user.
 * Free and signed-out users see ads, while Standard/Premium do not.
 */
export function useShouldShowAds(): boolean {
  const subscriptionTier = useUserStore((state) => state.user?.subscriptionTier)

  return useMemo(() => {
    if (!subscriptionTier) return true // signed-out users default to free tier experience
    return subscriptionTier === 'free'
  }, [subscriptionTier])
}

